<template>
  <div class="w-100">
    <div class="report-main-wrap" v-if="report_id != 'demo' && !loading">
      <div class="flex-space"></div>
      <el-dropdown trigger="click" style="margin-left: 20px">
        <el-button type="info" class="report-media-sort-button" style="width: auto">
          <span v-if="done_data"> <font-awesome-icon :icon="['far', 'user-check']" style="margin-right: 5px" />投稿済みのインフルエンサーのみ </span>
          <span v-else> <font-awesome-icon :icon="['far', 'user-friends']" style="margin-right: 5px" />全てのインフルエンサー </span>
          <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="done_data = false">全てのインフルエンサー</el-dropdown-item>
          <el-dropdown-item @click.native="done_data = true">投稿済みのインフルエンサーのみ</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="report-main-wrap" v-loading="loading">
      <div class="report-main-block">
        <div class="report-main-block-top">
          <div class="report-main-block-title">インフルエンサー数</div>
          <div class="report-main-block-num">
            {{ (done_data ? summary.influencer_num_done : summary.influencer_num) | addComma }}
          </div>
          <div class="report-main-block-detail">
            <font-awesome-icon :icon="['fal', 'images']" style="margin: 0 3px 0 12px; font-size: 12px" />
            投稿: {{ summary.post_num }}
          </div>
        </div>
        <div class="report-main-block-bottom">
          <div>インフルエンサー単価</div>
          <div>
            <span v-if="summary.cost != null">
              ¥<span> {{ (done_data ? summary.cost / summary.influencer_num_done : summary.cost / summary.influencer_num) | addComma }} </span>
            </span>
            <el-tooltip>
              <div slot="content">
                コストが設定されると自動で計算されます
              </div>
              <span v-if="summary.cost == null">
                <font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #aaa" />
              </span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="report-main-block">
        <div class="report-main-block-top">
          <div class="report-main-block-title">フォロワー合計</div>
          <div class="report-main-block-num">
            {{ (done_data ? summary.followers_count_done : summary.followers_count) | addComma }}
          </div>
        </div>
        <div class="report-main-block-bottom">
          <div>CPF<span style="font-size:10px">(フォロワー単価)</span></div>
          <div>
            <span v-if="summary.cpf != null"> ¥{{ summary.cpf }} </span>
            <el-tooltip>
              <div slot="content">
                コストが設定されると自動で計算されます
              </div>
              <span v-if="summary.cpf == null">
                <font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #aaa" />
              </span>
            </el-tooltip>
            <el-tooltip>
              <div slot="content">良好なフォロワー単価水準です</div>
              <span v-if="summary.cpf != null && summary.cpf < 1.5" style="color: #27b933"> <font-awesome-icon :icon="['fas', 'check-circle']" style="margin: 0 3px 0 5px" />Good </span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="report-main-block eg">
        <div class="report-main-block-top">
          <div class="report-main-block-title">
            エンゲージメント合計/率(%)
            <el-tooltip placement="top">
              <div slot="content">
                エンゲージメント合計は、いいねとコメントの合計数を示しています。
                <br />エンゲージメント率は、[各インフルエンサーの1投稿あたりの平均エンゲージメント合計値 ÷ フォロワー数合計]で計算された比率を示しています。
              </div>
              <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
            </el-tooltip>
          </div>
          <div class="report-main-block-num">
            {{ summary.engagement_count | addComma }}
            <span style="font-size:16px"> / {{ summary.average_engagement_rate }}% </span>
          </div>
          <div class="report-main-block-detail">
            <font-awesome-icon :icon="['fal', 'heart']" style="margin: 0 3px 0 6px; font-size: 12px" />
            いいね: {{ summary.like_count | addComma }}
            <font-awesome-icon :icon="['fal', 'comment']" style="margin: 0 3px 0 12px; font-size: 12px" />
            コメント: {{ summary.comments_count | addComma }}
          </div>
        </div>
        <div class="report-main-block-bottom">
          <div>CPE<span style="font-size:10px">(エンゲージメント単価)</span></div>
          <div>
            <span v-if="summary.cpe != null"> ¥{{ summary.cpe }} </span>
            <el-tooltip>
              <div slot="content">
                コストが設定されると自動で計算されます
              </div>
              <span v-if="summary.cpe == null">
                <font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #aaa" />
              </span>
            </el-tooltip>
            <el-tooltip>
              <div slot="content">
                良好なエンゲージメント単価水準です
              </div>
              <span v-if="summary.cpf != null && summary.cpf < 1.5" style="color: #27b933"> <font-awesome-icon :icon="['fas', 'check-circle']" style="margin: 0 3px 0 5px" />Good </span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="report-main-block right">
        <div class="report-main-block-top">
          <div class="report-main-block-title">コスト</div>
          <div class="report-main-block-num">
            <span v-if="summary.cost != null"> ¥{{ summary.cost | addComma }} </span>
            <font-awesome-icon v-else :icon="['far', 'hourglass-half']" style="color: #aaa" />
          </div>
          <div class="report-main-block-detail" style="font-size: 10px" v-if="summary.cost == null">
            <br />コストが設定されていません <br />「インフルエンサー」タブから<br />コストを設定してください
          </div>
        </div>
      </div>
    </div>

    <div class="report-main-wrap" style="margin-top: 30px" v-if="!loading">
      <div class="report-sub-block left">
        <div class="report-wrap-title">エンゲージメント推移</div>
        <div class="report-wrap-graph">
          <ReportGraph v-if="!loading" :height="'340'" :graph_data="graph_data" :done_data="done_data" :reRender="reRender" />
        </div>
      </div>
      <div class="report-sub-block right">
        <div class="report-wrap-title">想定リーチユーザー</div>
        <div style="margin-top: 30px; width:100%">
          <ReportDoughnut width="80%" :doughnut_data="done_data ? doughnut_data.data_done : doughnut_data.data" :reRender="reRender" v-if="!loading" style="margin-top: 20px" />
        </div>
        <div class="report-sub-block-gender-wrap">
          <div class="report-gender-legend">
            <div class="report-gender-legend-female"></div>
            <div>女性</div>
            <div class="flex-space"></div>
            <div>
              <span class="report-gender-num"> {{ done_data ? summary.female_ratio_done : summary.female_ratio }} </span>%
            </div>
          </div>
          <div class="report-gender-legend">
            <div class="report-gender-legend-male"></div>
            <div>男性</div>
            <div class="flex-space"></div>
            <div>
              <span class="report-gender-num"> {{ done_data ? summary.male_ratio_done : summary.male_ratio }} </span>%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportDoughnut from "../charts/ReportDoughnut";
import ReportGraph from "../charts/ReportGraph";


export default {
  name: "reportSummary",
  props: ["summary", "loading", "report_id", "done_data", "doughnut_data", "graph_data", "reRender"],
  components: {
        ReportGraph,
    ReportDoughnut,
  },
  data() {
    return {
    };
  },
  methods: {

  },
  filters: {
    addComma(val) {
      if (isNaN(val)) {
        return val;
      } else {
        return Math.floor(val).toLocaleString();
      }
    },
  },
};
</script>
